var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as Actions from '../../actions/fuse/navigation.actions';
import { fuseNavigationConfig } from '../../../fuse-configs/fuseNavigationConfig';
var initialState = fuseNavigationConfig;
var navigation = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.GET_NAVIGATION: {
            return __spreadArray([], state);
        }
        case Actions.SET_NAVIGATION: {
            return __spreadArray([], action.navigation);
        }
        case Actions.RESET_NAVIGATION: {
            return __spreadArray([], initialState);
        }
        default: {
            return state;
        }
    }
};
export default navigation;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/fuse/navigation.reducer.ts
// module id = 1164
// module chunks = 81